import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import * as SSO from "@10x/sso";
import { AppContext } from "@my-dld/contexts/AppContext";
import { Redirect, Route, Switch } from "react-router";
import ViewMyProfile from "./View";
import EditMyProfile from "./Edit";
import { normaliseMobileNumber } from "@eres/core/dist/StringUtils";
import ChangePassword from "./ChangePassword";
import NewAccount from "./NewAccount";
import VerifyEmail from "./VerifyEmail";
import VerifyAccount from "./VerifyAccount";


export function phoneNumber() {
	let value = SSO.getMobileNumber();
	if ( value ) {
		return value;
	} else return "-";
}

export function emailF() {
	let value = SSO.getEmail();
	if ( value ) {
		return value;
	} else return "-";
}

export function toMobileX( mobile: string ) {
	if ( mobile ) {
		mobile = normaliseMobileNumber( mobile );
		return mobile;
	} else return "";
}


export default class MyProfile extends Component<RoutedViewProps> {
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

	render() {
		const pp = this.props.match.url;
		return <Switch>
			<Route path={ pp + "/" } exact={ true }>
				<Redirect to={ pp + "/view" }/>
			</Route>
			<Route path={ pp + "/view" } component={ ViewMyProfile }/>
			<Route path={ pp + "/edit" } component={ EditMyProfile }/>
			<Route path={ pp + "/chpwd" } component={ ChangePassword }/>
			<Route path={ pp + "/newaccount" } component={ NewAccount }/>
			<Route path={ pp + "/verifyemail" } component={ VerifyEmail }/>
			<Route path={ pp + "/verify_account" } component={ VerifyAccount }/>
		</Switch>;
	}
}

export const picCache = {
	cacheId: new Date().getMilliseconds(),
	update: () => {
		picCache.cacheId = new Date().getMilliseconds();
	}
};
